import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertComponent } from '../../alert/alert.component';
import { CommonModule } from '@angular/common';
import { ExposedMapComponent } from '../exposed-map.component';

@Component({
  selector: 'app-exposed-map-control',
  standalone: true,
  imports: [
    AlertComponent,
    CommonModule,
    ExposedMapComponent,
    ReactiveFormsModule
  ],
  templateUrl: './exposed-map-control.component.html'
})
export class ExposedMapControlComponent {

  @Input()
  public alertMessage: string | null = 'Proszę wskazać na mapie przybliżoną lokalizację przeprowadzanych robót. Plik z planem sytuacyjnym będzie możliwy do załączenia w ostatnim kroku. Proszę przygotować stosowny plik.';

  @Input()
  public control: FormControl | undefined;

  @Input()
  public showDrawTerrain = false;

  public get isRequired(): boolean {
    return !!this.control?.hasValidator(Validators.required);
  }
}
